<template>
  <sh-heading :type="tag" :size-mobile="mobileSize" :size-desktop="desktopSize">
    <sc-text
      :field="textField"
      tag="span"
      :data-heading="tag"
      :class="{hint : isEditMode}"
    />
  </sh-heading>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Heading } from '@sohohouse/design-system'
import { Text } from '@sitecore-jss/sitecore-jss-vue'
import get from '~/helpers/get'
import ScRender from '../sc-render'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
export default {
  name: 'Heading',
  props: {
    textField: {
      default: () => ({})
    },
    tagField: {
      default: () => ({})
    },
    // not required, but in some cases can be custom default tag
    defaultTag: {
      default: 'h2'
    },
    mobileSize: {
      default: 'size-3'
    },
    desktopSize: {
      default: 'size-2'
    }
  },
  components: {
    scText: Text,
    ScRender,
    ShHeading: Heading
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    tag () {
      return get(this.tagField, 'value', this.defaultTag)
    }
  }
}
</script>

<style lang="scss" scoped>
.hint::after {
  content: attr(data-heading);
  @include font('070');
  margin-left: $space-050;
  background-color: $color-gray-2;
  color: $color-white;
  padding: $space-020 $space-050;
  border-radius: $space-020;
  box-shadow: $space-010 $space-010 $space-010 $color-cream;
}
</style>
